export class ErrorResponse {
	message: string;
	constructor(message: string) {
		this.message = message;
	}
}
